export default {
	data: {},
	id: "",
};
